// extracted by mini-css-extract-plugin
module.exports = {"posterArrowButtonPrev":"PosterArrowButtonPrev","isDisabled":"is-disabled"};